import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';

export const runFormulaOnMeasurementsRequestDto = z.object({
  measurementIds: z.string().array(),
});

export const runFormulaOnMeasurementsResponseDto = z.object({
  result: z.record(
    z.string(),
    z.union([
      z.object({ error: z.string() }),
      z.object({ success: z.boolean() }),
    ]),
  ),
});

export class RunFormulaOnMeasurementsRequestDto extends createZodDto(
  runFormulaOnMeasurementsRequestDto,
) {}

export class RunFormulaOnMeasurementsResponseDto extends createZodDto(
  runFormulaOnMeasurementsResponseDto,
) {}
